import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UserGroup, Sensor, SensorStatsSearchCriteria, SensorGroup, SensorReadingType, SensorInfo,
         SensorSource, SensorStatsResults, SensorReadingCriteria, SensorReadingUpdateCriteria, TimeZoneDisplay,
         SensorReadingTypeCount, LastSensorReading, SensorSearchCondition, SensorSearchCriteria3, PreEditObject, SensorDataInfo2, VirtualSensor} from '../../shared/models';
import moment from 'moment';
import { forkJoin, of } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { SensorService } from '../../shared/services/sensor.service';
import { UserService } from '../../shared/services/user.service';
import { AppComponent } from './../../app.component';
import { Message, MessageActionType, MessageType, AppComponentName } from '../../shared/models/Messages/message.model';
import { AppMessageService } from '../../shared/services/message.service';
import { SensorGroupService } from '@services/sensorgroup.service';
import { ChartData, ChartInfo } from '@models/Dashboard/chartData.model';
import { SensorReadingInfo } from '@models/EventLog/SensorReadingInfo.model';
import { CommonShared } from 'app/shared/classes/common';
import { Authorization } from 'app/shared/classes/authorization';
import { ActivatedRoute } from '@angular/router';
import { GpsDisplay, GpsInfo } from '@models/Map/gpsInfo.model';
import { SensorDataModalComponent, SensorDataModalParams } from './sensor-data-modal/sensor-data-modal.component';
import { VirtualSensorModalComponent, VirtualSensorModalParams } from './virtual-sensor-modal/virtual-sensor-modal.component';
import { SensorMapping } from 'app/shared/classes/sensorMapping';
import { Table } from 'primeng/table';
import { QuickCreateSensorgroupComponent, QuickCreateSensorgroupParams } from '../sensor-groups/quick-create-sensorgroup/quick-create-sensorgroup.component';
import { DateRanges } from '@models/ranges';
import { ChangeLogNotesParams, ChangeLogNotesComponent } from '../messages/changelog-notes/changelognotes.components';
import { ImportSensorComponent, ImportSensorModalParams } from './import-sensor-modal/import-sensor-modal.component';
import { SensorLabelComponent, SensorLabelModalParams } from './sensor-label-modal/sensor-label-modal.component';
import { Charting } from 'app/shared/classes/charting';
import { Time } from '@angular/common';
import { SensorCalibrationHistory, SensorCalibrationHistoryInfo, SensorCalibrationHistoryNotes } from '@models/Sensor/sensorCalibrationHistory.model';

interface DateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
};

@Component({
  standalone: false,
  selector: 'app-sensors',
  templateUrl: './sensors.component.html',
  styleUrls: ['./sensors.component.scss']
})

export class SensorsComponent implements OnInit {

  @ViewChild('chartRef') chartRef: any;
  @ViewChild('sensorTable') table: Table;
  
  public common = new CommonShared();
  public auth = new Authorization();
  public mapping = new SensorMapping();
  public charting = new Charting();

  modalDragOn: boolean = false;

  public sensorSearch = '';
  public searchRecallTimer: any;

  public userGroups: UserGroup[] = [];
  public associatedUserGroups: UserGroup[] = [];
  public isReadyAssociatedUserGroups = false;
  public isReadySensorGroups = false;
  public username = 'unknown';
  public isReadyAllSensors = false;
  public scanModalRef: BsModalRef;
  public scannedSensor = '';
  public visitedScan = false;
  public allSensorUUIDsDisplayed = false;
  public sensorEdited = false;
  public duplicateName = false;
  public duplicateUUID = false;
  public changeLogNotes = '';
  public sensor: Sensor;

  public displaySensorSearchResults: boolean = false;
  public preEditObjects: PreEditObject[] = [];

  public allGpsInfos: GpsInfo[] = [];
  public selectedGps: GpsDisplay;
  public displayedGps: GpsDisplay[];

  public sensorGroups: SensorGroup[] = [];
  public sensorGroup: SensorGroup;
  public availableDevices: MediaDeviceInfo[];
  public selectedDevice: MediaDeviceInfo;
  public selectedUserGroup: UserGroup;
  public sensorReadingTypes: SensorReadingType[] = [];
  public testDataRange: string = '';
  public virtualSensorEvaluateResults: string = '';
  public dataRangeSelectorTitle: string = '';
  public sensorDataOnDemandResults: SensorDataInfo2;
  public sensorDataOnDemandMessage: string = '';
  public sensorDataOnDemandName: string;

  public chart: ChartInfo = {
    sensor: undefined,
    sensorName: '',
    sensorReadings: [],
    dataTypes: [],
    chartData: [],
    chartDays: 7,
    yMinScale: undefined,
    yMaxScale: undefined,
    yMinIgnore: undefined,
    yMaxIgnore: undefined,
    yMinData: undefined,
    yMaxData: undefined,
    view: [1200,700]
  };

  public virtualChartData: ChartData[] = [];

  sensorCols = [];

  sensorColsWithoutSearch = [
    { field: 'checkbox', header: '', width: '3%' },
    { field: 'name', header: 'Name', width: '10%' },
    { field: 'uuid', header: 'UID', width: '19%' },
    { field: 'type', header: 'Type', width: '7%' },
    { field: 'Source', header: 'Source', width: '7%' },
    { field: 'captureNow', header: 'Connect', width: '4%' },
    { field: 'data', header: 'C', width: '2%' },
    { field: 'lastReading.date', header: 'Last Reading', width: '15%' },
    { field: 'searchResultsSummary', header: '', width: '0%' },
    { field: 'associatedsensorGroupNames', header: '', width: '0%' },
    { field: 'userName', header: 'Owner', width: '15%' },
    { field: 'modifiedDate', header: 'Last Modified', width: '12%' },
    { field: 'edit', header: '', width: '3%' },
    { field: 'delete', header: '', width: '3%' }
  ];

  sensorColsWithSearch = [
    { field: 'checkbox', header: '', width: '3%' },
    { field: 'name', header: 'Name', width: '10%' },
    { field: 'uuid', header: 'UID', width: '17%' },
    { field: 'type', header: 'Type', width: '5%' },
    { field: 'Source', header: 'Source', width: '5%' },
    { field: 'captureNow', header: 'Connect', width: '4%' },
    { field: 'data', header: 'C', width: '2%' },
    { field: 'lastReading.date', header: 'Last Reading', width: '15%' },
    { field: 'searchResultsSummary', header: 'Searched', width: '9%' },
    { field: 'associatedsensorGroupNames', header: 'Sensor Groups', width: '13%' },
    { field: 'userName', header: '', width: '0%' },
    { field: 'modifiedDate', header: 'Last Modified', width: '11%' },
    { field: 'edit', header: '', width: '3%' },
    { field: 'delete', header: '', width: '3%' }
  ];

  readingTypesCountCols = [
    { field: 'checked', header: '', width: '10%' },
    { field: 'id', header: 'Id', width: '15%' },
    { field: 'type', header: 'Reading Type Name', width: '60%' },
    { field: 'count', header: 'Count', width: '15%' }
  ];

  public generalConfig: any = {
    displayKey: 'name',
    search: true,
    height: '300px',
    placeholder: 'Select Option',
    noResultsFound: 'No options found!',
    searchOnKey: 'name'
  };

  public sensorSourceConfig: any = {
    displayKey: 'name',
    search: false,
    height: '300px',
    placeholder: 'Select Sensor Source',
    noResultsFound: 'No options found!',
    searchOnKey: 'name'
  };

  public gpsConfig: any = {
    displayKey: 'name',
    search: true,
    height: '300px',
    placeholder: 'Select Location',
    noResultsFound: 'No locations found!',
    searchOnKey: 'name'
  };

  public sensorSourceOptions = [ 'Physical', 'Virtual' ];
  public sensorSourceSelection: string = '';
  public sensorToAdd: Sensor;
  public allSensors: Sensor[] = [];
  public sensorsDisplayed: Sensor[] = [];
  public searchSensorForVirtualText: string = '';
  public searchSensorUUID: string = undefined;
  public searchedSensorUUID = false;
  public waitForSensorSearch: boolean = false;
  public waitForFunctionTest: boolean = false;
  public userNameTimer: any;
  public sensorModalRef: BsModalRef;
  public sensorReplaceModalRef: BsModalRef;
  public logModalRef: BsModalRef;
  public modalRef: BsModalRef;
  public sensorDataResultsModelRef: BsModalRef;
  //public calibrateModalRef: BsModalRef;
  public setOwnerModalRef: BsModalRef;
  public dateRangeSelectorRef: BsModalRef;
  public collectingDateRangeFor: string = '';
  public processingVirtualSensorReadings: boolean = false;
  public resultsOfSensorReadingDeletion: string = '';
  public processingSensorReadingsForGps: boolean = false;
  public processingSensorReadingsForGpsResults: string = '';
  public processingReadingCounts: boolean = false;
  public existingSensorUUID: string = '';
  public replacementSensorUUID: string = '';
  public scanningExistingSensor: boolean = true;
  public replacementSensorUUIDExists: boolean = false;
  public existingSensorReadingsCount: string = '';
  public existingSensorReadingsCheck: boolean = false;
  public readingTypesByCount: SensorReadingTypeCount[] = [];
  public sensorsSelected: Sensor[] = [];
  public calibrationHistory: SensorCalibrationHistory[] = [];
  loadingCalibrationHistory: boolean = false;

  pendingActiveCalibrationChanges: { calibrationId: number, isActive: boolean, sensorReadingTypeId: number }[] = [];
  notifyCalibrationHistoryActiveChanged: number = 0;

  config = {
    backdrop: false,
    ignoreBackdropClick: true
  };

  public chartOptions: any = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    animations: false,
    showXAxisLabel: true,
    xAxisLabel: 'Date-Time (Select range from the below scale)',
    showYAxisLabel: true,
    yAxisLabel:'Value',
    autoScale: true,
    legendTitle:'Reading Type(s)',
    timeline: true,
    colorScheme: {
      domain: [ '#046dd6', '#800080', '#42f55a', '#ffc107', '#fa0f0f' ]
    }
  };

  public sensorTypes: string[] = [ "Miflora", "MET", "Parrot", "SensorPush", "Thermo", "IRT", "Govee" ];    // This needs to be read from the Settings table

  public invalidDates: moment.Moment[] = [];
  public selectedDateRange: DateRange = { startDate: moment().startOf('day'), endDate: moment().endOf('day') };
  isInvalidDate = (m: moment.Moment) => this.invalidDates.some(d => d.isSame(m, 'day'));
  public ranges = DateRanges;

  public selectedTimeZone: TimeZoneDisplay = TimeZoneDisplay.Local;
  public selectedTimeZoneOffset: number = moment().utcOffset();

  public globalSwitch: boolean = false;
  public btMacAddressPrefixes: {};
  public exportFilename: string = 'export-selected-sensors';

  constructor(public toastr: ToastrService, public modalService: BsModalService, public confirmationService: ConfirmationService,
              private global: AppComponent, public _userService: UserService, public _sensorService: SensorService,
              public _appMessageService: AppMessageService, public _sensorGroupService: SensorGroupService, private route: ActivatedRoute) {
    this.globalSwitch = global.globalSwitch;
    this.linkedSearch = route.snapshot.queryParamMap.get('search');
  }


  ngOnInit() {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {

        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp() {
    this.prepareMainTableLayoutWithSearchResults(false);
    this.getBtMacAddressPrefixes();
    this.loadSavedSettings();
    this.getGpsLocations();
    this.getSensorReadingTypesWithIDs();
    this.getSensorGroups();
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  loadSavedSettings() {
    [this.selectedTimeZone, this.selectedTimeZoneOffset] = this.common.setTimeZoneSelection(localStorage.getItem('TimeZoneSelected'));
  }


  openScanModal(template: TemplateRef<any>): void {
    this.scanModalRef = this.modalService.show(template);
    this.scannedSensor = '';
  }


  public addSensor(): void {
    if (this.scannedSensor == undefined || this.scannedSensor === '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }

    this.scannedSensor = this.createUUID(this.scannedSensor);
    this.allSensors.forEach(sensor => {
      if (sensor['uuid'].toLowerCase() === this.scannedSensor.toLowerCase()) {
        const sensorIndex = this.allSensors.indexOf(sensor);
        sensor['checked'] = true;
        this.sensorToAdd = sensor;
        this.scannedSensor = '';
        this.allSensors.splice(sensorIndex, 1);
        this.allSensors.unshift(this.sensorToAdd);
        this.toastr.success('Sensor found in database and adding to list');
        if (!this.allSensorUUIDsDisplayed) {
          this.buildSensorUUIDDisplayList(false);
        }
        return;
      }
    });

    if (!(this.scannedSensor === '')) {
      this.sensorToAdd = this.createNewSensorWithUUID(this.scannedSensor.toLowerCase(), SensorSource.Physical);
      this.allSensors.unshift(this.sensorToAdd);
      this.toastr.success('Successfully added new sensor');
      if (!this.allSensorUUIDsDisplayed) {
        this.buildSensorUUIDDisplayList(false);
      }
      this.scannedSensor = '';
    }
  }


  public scannedSensorQR(): void {
    if (this.scannedSensor == undefined || this.scannedSensor === '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }
    this.searchSensorUUID = this.scannedSensor;
    this.scanModalRef.hide();
  }


  public createUUID(uuid): string {
    uuid = uuid.split(':').join('');
    const formattedUUID = [];
    const maxLength = 36;
    let uuidLengthTracker = uuid.length - 1;
    for (let i = 0; i <= maxLength - 1; i++) {
      if (i === 12 || i === 17 || i === 22 || i === 27) {
        formattedUUID.unshift('-');
      } else if (uuidLengthTracker >= 0) {
        formattedUUID.unshift(uuid.charAt(uuidLengthTracker));
        uuidLengthTracker--;
      } else {
        formattedUUID.unshift('0');
      }
    }
    return formattedUUID.join('');
  }


  public scanComplete(event: string): void {
    this.visitedScan = false;
    if (this.scannedSensor === '') {
      const splitEvent = this.createUUID(event);
      this.allSensors.forEach(sensor => {
        if (sensor['uuid'].toLowerCase() === splitEvent.toLowerCase() && sensor['checked'] === true) {
          this.toastr.error('This sensor is already selected');
          this.visitedScan = true;
          return;
        }
      });
      if (!this.visitedScan) {
        this.toastr.success('Scanned ' + event);
        this.scannedSensor = event;
        this.visitedScan = false;
      }
    } else {
      this.toastr.warning('Please choose to add or ignore current sensor');
    }

  }


  public camerasFound(cameras: MediaDeviceInfo[]) {
    this.availableDevices = cameras;
    if (this.availableDevices.length > 0) {
      this.onDeviceSelectChange(this.availableDevices[this.availableDevices.length-1].deviceId);
    }
  }


  onDeviceSelectChange(selectedValue: string) {
    this.selectedDevice = this.availableDevices.find(x => x.deviceId == selectedValue);
  }


  ignoreSensor(): void {
    if (this.scannedSensor === '') {
      this.toastr.warning('Please scan a sensor');
    } else {
      this.toastr.warning('Ignored ' + this.scannedSensor);
      this.scannedSensor = '';
    }
  }


  onCancelButton() {
    this.modalRef.hide();
  }


  getAllSensors(): void {
    this._sensorService.getAllSensorsWithCalibrations().subscribe(
      results => {
        if (results != null) {
          this.allSensors = this.mapping.mapSensorInfos2Sensors(results, this.allGpsInfos);
          this.allSensors.forEach(s => {
            this.setSelectedUserGroup(s);
            this.updateUserInfoForSensor(s);

            if (s.sensorReadingTypes == null) {
              s.sensorReadingTypes = [];
              s.loadStatus = "";
            }

            s.nameRevert = s.name;
            s.brandRevert = s.type;
            s.checked = false;
            s.displayedSensorName = this.common.getSensorDisplayName(s)
          });

          this.isReadyAllSensors = true;
          this.sensorsDisplayed = [...[]];

          this.sensorSearch = localStorage.getItem('SensorSearchBox');

          if (this.sensorSearch != undefined && this.sensorSearch != '') {
            this.startTimer4RecallLastSearchFilter();
          }
          else if (this.sensorGroup != null) {
            this.selectSensorsInSensorGroup(this.sensorGroup);
          }

        } else {
          this.toastr.warning('No Sensors found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor list');
      });
  }


  searchSensorsByConditions(sensorSearchConditions: SensorSearchCondition[]): void {
    var newSearchCriteria: SensorSearchCriteria3 = {
      sensorIds: this.sensorsDisplayed.map(x => x.id),
      searchConditions: sensorSearchConditions,
      searchResultsCountLimit: 800
    }

    this._sensorService.searchSensorsUsingConditions(newSearchCriteria).subscribe(
      results => {
        if (results != null) {
          var searchResults = this.mapping.mapSensorInfos2Sensors(results, this.allGpsInfos);
          
          if (searchResults.length > 0) {
            this.sensorsInSearchResults(searchResults);
          }
          else {
            this.sensorsDisplayed = [];
            this.toastr.warning('No Sensors found');
          }

          this.isReadyAllSensors = true;
        } else {
          this.toastr.warning('No Sensors found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor list');
      });
  }


  sensorsInSearchResults(sensorResults: Sensor[]) {
    if (sensorResults == undefined) return;

    const searchLimit = 800;
    let checkedCount = 0;
    this.sensorGroup = null;

    this.sensorsDisplayed = this.allSensors.filter(s => s.checked === true);

    sensorResults.forEach(sensorWithResults => {
      var matchingSensor = this.allSensors.find(a => a.id == sensorWithResults.id);
      if (matchingSensor != undefined) {
        this.updateSensorWithSearchResults(matchingSensor, sensorWithResults);
        this.findAssociatedSensorGroupNames(matchingSensor);
        this.sensorsDisplayed.push(matchingSensor);
      }
    });

    const displayCount = (this.sensorsDisplayed.length > checkedCount + searchLimit) ? checkedCount + searchLimit : this.sensorsDisplayed.length;

    this.sensorsDisplayed.sort((x, y) => (x.checked === y.checked) ? 0 : x.checked ? -1 : 1);
    this.sensorsDisplayed = this.sensorsDisplayed.slice(0, displayCount);

    this.updateInternalSensorSourcesToInternal(this.sensorsDisplayed);

    this.getLastSensorReadingDatesForSensors(this.sensorsDisplayed);

    var sensorsToLoadCalibrationHistory = this.sensorsDisplayed.filter(x => x.sensorCalibrationHistory == null);
    if (sensorsToLoadCalibrationHistory.length > 0) {
      this.loadCalibrationHistoryForSensors(sensorsToLoadCalibrationHistory);
    }

  }


  getGpsInfo(gpsInfo: GpsInfo): GpsInfo {
    if (gpsInfo == undefined)
      return this.newGpsInfo();

    var gpsInfo = this.allGpsInfos.find(x => x.id == gpsInfo.id);

    return (gpsInfo != undefined) ? gpsInfo : this.newGpsInfo();
  }


  newGpsInfo(): GpsInfo {
    var newGpsInfo: GpsInfo = {
      id: 0,
      gpsLong: 0,
      gpsLat: 0,
      gpsAlt: 0,
      locationDescription: ''
    }
    return newGpsInfo;
  }


  updateInternalSensorSourcesToInternal(sensors: Sensor[]) {
    sensors.forEach(sensor => {
      if (sensor.uuid.startsWith('sensorgroup-')) {
        sensor.source = SensorSource.Internal;
      }
    });
  }


  createNewUUID() {
    return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
       var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
       return v.toString(16);
    });
  }


  duplicateUUIDcheckByUUID(uuid: string): boolean {
    var compareUUID = uuid.toLowerCase();

    this.allSensors.forEach(sensor => {
      var existingUUID = sensor.uuid.toLowerCase();
      var currentUUID = (this.sensor != undefined) ? this.sensor.uuid.toLowerCase() : '';

      if(existingUUID == compareUUID && existingUUID != currentUUID) {
        return true
      }
    });

    return false;
  }


  createNewSensorWithUUID(newUUID: string, sensorSource: SensorSource): Sensor {
    while (newUUID == undefined || newUUID == '' || this.duplicateUUIDcheckByUUID(newUUID)) {
      newUUID = this.createNewUUID();
    }

    var sensor: Sensor = {
      id: 0,
      uuid: newUUID,
      type: undefined,
      name: undefined,
      sensorReadingTypes: null,
      sensorReadingTypeNames: '',
      checked: true,
      modifiedDate: new Date(),
      sensorCalibrationHistory: undefined,
      userName: this.username,
      userGroupId: null,
      displayedSensorName: '',
      displayedOwner: undefined,
      source: sensorSource,
      notes: '',
      gpsLocation: this.newGpsInfo(),
      virtualSensor: this.createNewVirtualSensorDetails()
    }

    sensor.displayedSensorName = this.common.getSensorDisplayName(sensor);
    this.setSelectedUserGroup(sensor);
    this.updateUserInfoForSensor(sensor);

    return sensor;
  }


  createNewVirtualSensorDetails(): VirtualSensor {
    var newVirtualSensor: VirtualSensor = {
      isDisabled: true,
      calculateFreq: 30,
      calculateDelay: 0,
      calculateHourOfDay: 0,
      calculateMinuteOfHour: 0,
      functions: [],
      parameters: [],
      id: 0,
      parentSensorId: 0
    }

    return newVirtualSensor;
  }


  getSensorGroups(): void {
    this.isReadySensorGroups = false;
    this._sensorGroupService.getSensorGroupsWithSensors().subscribe(
      results => {
        if (results != null) {
          this.sensorGroups = results;
          this.isReadySensorGroups = true;
        } else {
          this.toastr.warning('No Sensor Groups found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  parseSensorUUID(): string {
    const matchExp = '[a-zA-Z][-]';
    const matchesPattern = this.searchSensorUUID.substring(0, 2).search(matchExp) >= 0;
    const toReplacePattern = new RegExp('[;\\\\/:*?"<>|&\']');
    if (matchesPattern) {
      return this.searchSensorUUID.substring(2, this.searchSensorUUID.length).toLowerCase().replace(/:/g, '');
    }
    return this.searchSensorUUID.toLowerCase().replace(/:/g, '');
  }


  duplicateNameCheck(sensor: Sensor): boolean {
    if (sensor === undefined || sensor.name == undefined) return;
    this.duplicateName = false;

    const sensorIndex = this.allSensors.findIndex(x => (x.name != undefined) ? (x.name.toLowerCase() === sensor.name.toLowerCase() && x.id != sensor.id) : false);
    if (sensorIndex > -1) {
      this.toastr.warning('Sensor name ' + sensor.name + ' is already in use');
      this.duplicateName = true;
      return true;
    }

    this.duplicateName = false;
    return false;
  }


  duplicateUUIDCheck(sensor: Sensor): boolean {
    if (sensor == undefined) return;
    this.duplicateUUID = false;

    const sensorIndex = this.allSensors.findIndex(x => (x.uuid != undefined) ? (x.uuid.toLowerCase() === sensor.uuid.toLowerCase() && x.id != sensor.id) : false);
    if (sensorIndex > -1) {
      this.toastr.error('Sensor UUID ' + sensor.uuid + ' is already in use');
      this.duplicateUUID = true;
      return true;
    }

    this.duplicateUUID = false;
    return false;
  }


  updateOrCreateSensor(sensor: Sensor, check4Duplicates: boolean) {
    if (sensor == undefined) {
      this.toastr.warning('Sensor to update or create is undefined');
      return;
    }
    if (check4Duplicates && this.duplicateUUIDCheck(sensor)) {
      return;
    }

    sensor.modifiedDate = new Date();
    sensor.source = (this.sensorSourceSelection == 'Physical') ? SensorSource.Physical : SensorSource.Virtual;

    if (sensor.source != SensorSource.Virtual) {
      sensor.virtualSensor = undefined;
    }
    else {
      sensor.virtualSensor.parameters = sensor.virtualSensor.parameters.filter(x => x.name != undefined && x.name != '');
    }

    if (sensor.id == 0) {
      this.saveNewSensor(sensor);
    }
    else {
      sensor.inlineEdited = false;
      this.updateSensors([sensor]);
    }

    //this.saveActiveCalibrationChanges();
    //this.createOrUpdateCalibrationHistory(sensor);

    if (this.sensorModalRef != undefined) {
      this.sensorModalRef.hide();
    }
  }


  saveNewSensor(sensor: Sensor) {
    sensor.userName = this.username;
    this.updateUserInfoForSensor(sensor);

    if (sensor.gpsLocation.gpsAlt == 0 && sensor.gpsLocation.gpsLong == 0 && sensor.gpsLocation.gpsLat) {
      sensor.gpsLocation = undefined;
    }

    var sensorInfosToUpdate = this.mapping.mapSensors2SensorInfos([sensor]);

    this._sensorService.createSensor(sensorInfosToUpdate).subscribe(results => {
      if (results != null) {
        this.getGpsLocations();
        this.toastr.success('New Sensor added');
        var sensorInfos: SensorInfo[] = results;

        sensorInfos.forEach(x => {
          var newSensor = this.mapping.mapSensorInfo2Sensor(x, this.allGpsInfos);
          this.updateUserInfoForSensor(newSensor);
          this.createMessageData(MessageActionType.New, newSensor, 'New sensor ' + this.common.getSensorDisplayName(newSensor));
          this.allSensors = [...this.allSensors, newSensor];
          this.sensorsDisplayed = [...this.sensorsDisplayed, newSensor];
        });

        this._sensorService.clearCachedVariables();
      }
      else {
        this.toastr.warning('Error adding new sensor');
      }
    });
  }


  updateSensors(sensors: Sensor[]) {
    var sensorsToUpdate: Sensor[] = [];

    if (sensors == undefined || sensors.length < 1) {
      sensorsToUpdate = this.sensorsDisplayed.filter(s => s.inlineEdited === true);
    }
    else {
      sensorsToUpdate = sensors;
    }

    if (sensorsToUpdate == undefined || sensorsToUpdate.length < 1) {
      this.toastr.warning('Sensor(s) update failed');
      return;
    }

    sensorsToUpdate.forEach(sensor => {
      // if (sensor.userName == undefined || sensor.userName == '') {
        sensor.userName = this.username;
      // }
      
      if (sensor.inlineEdited == true) {
        this.setSelectedUserGroup(sensor);
      }
      
      this.updateUserInfoForSensor(sensor);

      if (sensor.source == SensorSource.Virtual) {
        sensor.virtualSensor.functions.forEach(x => {
          if (x.readingType == undefined || x.readingType == '') {
            x.readingType = 'not specified';
          }
        });
      }
    });

    var sensorInfosToUpdate = this.mapping.mapSensors2SensorInfos(sensorsToUpdate);

    this._sensorService.updateSensor(sensorInfosToUpdate).subscribe(results => {
      if (results != null) {
        sensorsToUpdate.forEach(sensor => {
          var preEditObject = this.preEditObjects.find(x => x.sensorId == sensor.id);
          this.createMessageData(MessageActionType.Edited, sensor, this.common.getEditChanges4Sensors(sensor, (preEditObject != undefined) ? preEditObject.preEditObjectAsJSONString : ''));
          sensor.inlineEdited = false;

          // Create or update calibration history records
          this.createOrUpdateCalibrationHistory(sensor);
          //this.createCalibrationHistoryForChangedCalibrations(sensor, preEditObject);
        });

        this.toastr.success('Sensor(s) updated');
        this.sensorEdited = false;

        this._sensorService.clearCachedVariables();
        this.getGpsLocations();
      }
      else {
        this.toastr.warning('Sensor update(s) failed');
      }
    });
  }


  updateUserInfoForSensor(sensor: Sensor) {
    if (this.selectedUserGroup != null && this.selectedUserGroup.id > 0) {
      sensor.userGroupId = this.selectedUserGroup.id;
      sensor.userGroup = this.selectedUserGroup.name;
    }
    else {
      sensor.userGroupId = null;
      sensor.userGroup = '';
    }

    sensor.displayedOwner = this.getOwnerName(sensor);
    this.auth.mapUserAccessForSensor(sensor, this.globalSwitch, this.username, this.userGroups);
  }


  getOwnerName(sensor: Sensor): string {
    if (sensor.userGroupId != undefined) {
      return sensor.userGroup;
    }
    else if (sensor.userName != undefined) {
      return sensor.userName;
    }
    else {
      return undefined;
    }
  }


  updateSensorDetails(sensor: Sensor) {
    var changedSensor = this.sensorsDisplayed.find(s => s.id === sensor.id);
    if (changedSensor != null) {
      changedSensor.inlineEdited = true;
      this.sensorEdited = true;
      this.duplicateNameCheck(changedSensor);
      this.duplicateUUIDCheck(changedSensor);
    }
  }


  revertSensorChanges() {
    this.sensorsDisplayed.forEach(s => {
      s.inlineEdited = false;
      s.name = s.nameRevert;
      s.type = s.brandRevert;
    });
    this.sensorEdited = false;
  }


  buildSensorUUIDDisplayList(showAll: boolean) {
    this.allSensorUUIDsDisplayed = showAll;

    if (!showAll) {
      this.sensorsDisplayed = this.allSensors.filter(s => s.checked === true);
    } else {
      this.sensorsDisplayed = this.allSensors;
    }

    this.sensorsDisplayed.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1);
  }


  getCheckedSensorUUIDs(): number {
    let count = 0;
    this.allSensors.forEach(sensor => {
      if (sensor.checked) {
        count++;
      }
    });
    return count;
  }


  autoUpdateNameForUUID(sensor: Sensor) {
    if (sensor.name == undefined || sensor.name === '') {
      sensor.name = this.common.extractNameFromUUID(sensor.uuid, this.btMacAddressPrefixes);
      if (sensor.name !== '') {
        sensor.inlineEdited = true;
        this.sensorEdited = true;
      }
    }
  }

  autoUpdateTypeForUUID(sensor: Sensor) {
    if (sensor.type == undefined || sensor.type === '') {
      sensor.type = this.common.extractTypeFromUUID(sensor.uuid, this.btMacAddressPrefixes);
      if (sensor.type !== '') {
        sensor.inlineEdited = true;
        this.sensorEdited = true;
      }
    }
  }


  getBtMacAddressPrefixes(): void {
    this.allSensors = [];
    this._sensorService.getBtMacAddressPrefixes().subscribe(
      results => {
        if (results != null) {
          this.btMacAddressPrefixes = results;
        } else {
          this.toastr.warning('No bluetooth mac address prefixes found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving bluetooth mac address prefixes');
      });
  }


  extractMacAddressFromUUID(uuid: string): string {
    let macAddress = '';
    if (uuid.length >= 12) {
      macAddress = uuid.substr(uuid.length - 12).toUpperCase();

      return  macAddress.slice(0, 2) + ':' +
              macAddress.slice(2, 4) + ':' +
              macAddress.slice(4, 6) + ':' +
              macAddress.slice(6, 8) + ':' +
              macAddress.slice(8, 10) + ':' +
              macAddress.slice(10, 12);
    }

    return '';
  }


  // Search text passed in by a link (e.g. from the home page search), used once in place of the saved search
  private linkedSearch: string | null = null;


  startTimer4RecallLastSearchFilter() {
    this.searchRecallTimer = setTimeout(() => {
      if (this.table != null) {
        this.sensorSearch = this.linkedSearch ?? localStorage.getItem('SensorSearchBox');
        this.linkedSearch = null;
        if (this.sensorSearch == undefined) {
          this.sensorSearch = "";
        }
        this.searchSensorsTextChanged();
      }
    },500);
  }


  clearSearchFilter() {
    this.sensorSearch = '';
    this.displaySensorSearchResults = false;
    this.searchSensorsTextChanged();
  }


  searchSensorsTextChanged() {
    localStorage.setItem('SensorSearchBox', this.sensorSearch);

    let checkedCount = 0;
    var lastModifiedSearchOptions: string[] = [ "newest", "lastmodified", "last modified", "recent", "latest" ];
    var sensorSearchConditions = this.getSensorSearchConditions(this.sensorSearch); 

    if (this.sensorSearch === '') {
      this.sensorsDisplayed = this.sensorsDisplayed.filter(s => s.checked === true);
      checkedCount = this.sensorsDisplayed.length;
      this.prepareMainTableLayoutWithSearchResults(false);
    }
    else if (lastModifiedSearchOptions.includes(this.sensorSearch)) {
      this.prepareMainTableLayoutWithSearchResults(false);
      this.searchSensorsBy('last modified');
    }
    else if (sensorSearchConditions != undefined && sensorSearchConditions.length > 0) {
      localStorage.setItem('SensorSearchBox', '');    // Clearing saved searches for conditions because of current problem where on page loads, search results being loaded 5 times
      this.prepareMainTableLayoutWithSearchResults(true);
      this.searchSensorsByConditions(sensorSearchConditions);
    }
    else {
      this.prepareMainTableLayoutWithSearchResults(false);
      this.searchSensorsBy('uuid|name|type|source|checked');
    }

    this.sensorsDisplayed.forEach(x => {
      if (x.associatedsensorGroupNames == undefined || x.associatedsensorGroupNames == '') {
        this.findAssociatedSensorGroupNames(x);
      }
    });

    this.sensorCheckedChanged();
  }


  prepareMainTableLayoutWithSearchResults(withSearchResults: boolean) {
    if (withSearchResults) {
      this.displaySensorSearchResults = true;
      this.sensorCols = this.sensorColsWithSearch;
    }
    else {
      this.displaySensorSearchResults = false;
      this.sensorCols = this.sensorColsWithoutSearch;
    }
  }


  getLastSensorReadingDatesForSensors(sensors: Sensor[]) {
    var unloadedSensorList = sensors.filter(x => !x.lastReading.isLoaded && !x.lastReading.waitingForLoad);

    if (unloadedSensorList.length < 1) {
      return;
    }

    var sensorIds = unloadedSensorList.map(y => y.id);

    unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = true);

    this._sensorService.getLastSensorReadings(sensorIds).subscribe(results => {

      if (results != null) {
        var lastReadings: LastSensorReading[] = results;

        lastReadings.forEach(x => {
          var sensor = unloadedSensorList.find(y => y.id == x.sensorId);

          if (sensor != undefined) {
            sensor.lastReading.date = moment.utc(x.date).toDate();
            sensor.lastReading.isLoaded = true;
            sensor.lastReading.displayColor = this.common.getColorCodeForLastReadingDate(sensor.lastReading.date);
          }

          sensor.lastReading.waitingForLoad = false;
        });
        unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = false);
      }
      else {
        unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = false);
        this.toastr.warning('Failed to retrieve last sensor readings info');
      }
    });
  }

  
  getSensorSearchConditions(searchText: string): SensorSearchCondition[] {
    // Only the operators supported by the API's GetSensorsWithSearch
    const conditionOperators = [ '>', '<', '=' ];
    var splitParms = (searchText ?? '').trim().split(/\s+/);

    // Anything else (e.g. a multi-word sensor name like "LU Weather Station") is a free text search
    if (splitParms.length !== 3 || !conditionOperators.includes(splitParms[1])) {
      return [];
    }

    var newSearchConditions: SensorSearchCondition[] = [];

    var newSearchCondition: SensorSearchCondition = {
      parameter: splitParms[0].toLowerCase(),
      condition: splitParms[1],
      value: splitParms[2]
    }

    newSearchConditions.push(newSearchCondition);
    return newSearchConditions;
  }


  searchSensorsBy(parameter: string) {
    this.sensorGroup = null;
    const searchLimit = 800;
    let checkedCount = 0;

    this.sensorSearch = this.sensorSearch.toLowerCase();

    var sensorsToSearch = (this.sensorsDisplayed != undefined && this.sensorsDisplayed.length > 0) ? this.sensorsDisplayed : this.allSensors;

    var searchResults: Sensor[] = [];

    switch (parameter.toLowerCase()) {
      case 'last modified':
        searchResults = sensorsToSearch.sort((x, y) => (x.modifiedDate === y.modifiedDate) ? 0 : x.modifiedDate > y.modifiedDate ? -1 : 1);
        break;
    
      case 'uuid|name|type|source|checked':
        searchResults = sensorsToSearch.filter(s => (s.uuid != undefined ? s.uuid.toLowerCase().includes(this.sensorSearch) : false) ||
                                                    (s.name != undefined ? s.name.toLowerCase().includes(this.sensorSearch) : false) ||
                                                    (s.type != undefined ? s.type.toLowerCase().includes(this.sensorSearch) : false) ||
                                                    (s.searchResultsSummary != undefined ? s.searchResultsSummary.toLowerCase().includes(this.sensorSearch) : false) ||
                                                    (s.associatedsensorGroupNames != undefined ? s.associatedsensorGroupNames.toLowerCase().includes(this.sensorSearch) : false) ||
                                                    (s.source != undefined ?  SensorSource[s.source].toLowerCase().includes(this.sensorSearch) : false) );
        break;

      default:
        break;
    }
    
    const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

    //searchResults.sort((x, y) => (x.checked === y.checked) ? 0 : x.checked ? -1 : 1);

    //var sensorIds = searchResults.slice(0, displayCount).map(x => x.id);
    //this.sensorsDisplayed = this.allSensors.filter(x => sensorIds.includes(x.id));

    //this.sensorsDisplayed.sort((x, y) => (x.checked === y.checked) ? 0 : x.checked ? 1 : -1);

    this.sensorsDisplayed = searchResults.slice(0, displayCount);

    this.updateInternalSensorSourcesToInternal(this.sensorsDisplayed);

    this.getLastSensorReadingDatesForSensors(this.sensorsDisplayed);

    var sensorsToLoadCalibrationHistory = this.sensorsDisplayed.filter(x => x.sensorCalibrationHistory == null);
    if (sensorsToLoadCalibrationHistory.length > 0) {
      this.loadCalibrationHistoryForSensors(sensorsToLoadCalibrationHistory);
    }
  }


  createMessageData(msgActionType: MessageActionType, sensor: Sensor, msgNote: string) {
    const sensorShortName = (sensor.uuid.length < 10) ? sensor.uuid : sensor.uuid.substring(0,3) + '...' + sensor.uuid.substring(sensor.uuid.length-6);
    const displayName = (sensor.name != undefined && sensor.name !== '') ? sensor.name : sensorShortName;

    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.Sensors,
      actionType: msgActionType,
      appComponentItem: displayName,
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: null
    }

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';

    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: 0,
      category: ''
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }
  

  getSensorStatsAndData(sensor: Sensor) {
    sensor.loadStatus = "loading";
    var sensorStatsSearchCriteria: SensorStatsSearchCriteria = {
      sensorId: sensor.id,
      returnLastXHours: 24,
      retrieveRawValues: false
    }

    this._sensorService.getSensorStatsAndData(sensorStatsSearchCriteria, '').subscribe(
      results => {
        if (results != null) {
          sensor.sensorReadingInfos = results.sensorReadingInfos;
          sensor.sensorReadingInfos.forEach(x => x.createdDate = new Date(moment.utc(x.createdDate).local().toDate()));
          this.prepareSensorStatsForDisplay(sensor, results);
        } else {
          this.toastr.warning('Unable to retrieve data for sensor');
        }
        return;
      },
      err => {
        this.toastr.error('Unable to retrieve data for sensor');
      });
  }


  prepareSensorStatsForDisplay(sensor: Sensor, sensorStatsResults: SensorStatsResults) {
    sensor.sensorReadingInfos = sensorStatsResults.sensorReadingInfos;
    if (sensor.sensorReadingInfos == undefined) {
      sensor.sensorReadingInfos = [];
    }

    sensor.last1HourIngestCount = sensorStatsResults.stat1Hour;
    sensor.last4HoursIngestCount = sensorStatsResults.stat4Hours;
    sensor.last24HoursIngestCount = sensorStatsResults.stat24Hours;
    sensor.loadStatus = "ready";
  }


  selectSensorsInSensorGroup(sensorGroup: SensorGroup) {
    localStorage.setItem('SensorSearchBox', '');

    if (sensorGroup == undefined || sensorGroup.sensors == undefined) return;

    this.sensorSearch = '';
    const searchLimit = 800;
    let checkedCount = 0;

    var searchResults = this.allSensors.filter(s => s.checked === true);

    sensorGroup.sensors.forEach(s => {
      var sensor = this.allSensors.find(a => a.id == s.id);
      if (sensor != undefined) {
        searchResults.push(sensor);
      }
    });
    searchResults = [...searchResults];

    const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

    searchResults.sort((x, y) => (x.checked === y.checked) ? 0 : x.checked ? -1 : 1);

    var sensorIds = searchResults.slice(0, displayCount).map(x => x.id);
    this.sensorsDisplayed = this.allSensors.filter(x => sensorIds.includes(x.id));

    this.sensorsDisplayed.sort((x, y) => (x.checked === y.checked) ? 0 : x.checked ? 1 : -1);

    this.updateInternalSensorSourcesToInternal(this.sensorsDisplayed);

    this.getLastSensorReadingDatesForSensors(this.sensorsDisplayed);
    
    this.sensorsDisplayed.forEach(x => {
      if (x.associatedsensorGroupNames == undefined || x.associatedsensorGroupNames == '') {
        this.findAssociatedSensorGroupNames(x);
      }
    });

    var sensorsToLoadCalibrationHistory = this.sensorsDisplayed.filter(x => x.sensorCalibrationHistory == null);
    if (sensorsToLoadCalibrationHistory.length > 0) {
      this.loadCalibrationHistoryForSensors(sensorsToLoadCalibrationHistory);
    }
  }


  getSensorReadingTypes(sensor: Sensor, template: TemplateRef<any>, loadingMessage: string): void {
    this._sensorService.getReadingTypesForSensors([sensor.id], loadingMessage).subscribe(
      results => {
        if (results != null) {
          sensor.sensorReadingTypes = results;
          this.common.sortArrayByTypeParm(sensor.sensorReadingTypes);

          sensor.sensorReadingTypeNames = (sensor.sensorReadingTypes != undefined) ? sensor.sensorReadingTypes.map(x => x.type).join(', ').toLowerCase() : undefined;
        } else {
          this.toastr.warning('No sensor reading types found for ' + sensor.name);
        }

        if (template != undefined) {
          this.sensorModalRef = this.modalService.show(template, this.config);
        }
        return;
      },
      err => {
        if (template != undefined) {
          this.sensorModalRef = this.modalService.show(template, this.config);
        }
        this.toastr.error('Error occurred while retrieving sensor reading types');
      });
  }


  getGpsLocations() {
    this._sensorService.getGpsLocations().subscribe(
      results => {
        if (results != null) {
          this.allGpsInfos = results;
          this.displayedGps = [ { id: 0, name: 'Empty' }, { id: 0, name: 'New' } ];
          this.allGpsInfos.forEach(x => {
            this.displayedGps.push( { id: x.id, name: `id:${x.id}, lat:${x.gpsLat}, long:${x.gpsLong}, ${x.locationDescription}`})
          });
        }
        else {
          this.toastr.warning('No GPS locations found.');
        }
        this.getAssociatedUserGroups();
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving GPS locations.');
      });
  }


  getSensorReadingTypesWithIDs(): void {
    this._sensorService.getSensorDatatypesWithIDs().subscribe(
      results => {
        if (results != null) {
          this.sensorReadingTypes = results;
          this.common.sortArrayByTypeParm(this.sensorReadingTypes);
        } else {
          this.toastr.warning('No sensor reading types found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor reading types.');
      });
  }


  setSelectedUserGroup(sensor: Sensor) {
    if (sensor.userGroupId == null || sensor.userGroupId < 1) {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    } else {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == sensor.userGroupId);
    }
  }


  newSensor(template: TemplateRef<any>) {
    const sensorsToUpdate = this.sensorsDisplayed.filter(s => s.inlineEdited === true);
    if (sensorsToUpdate.length > 0) {
      this.toastr.info('Please finish inline editing or revert changes before editing this sensor');
      return;
    }

    this.selectedGps = null;

    this.searchSensorForVirtualText = '';
    this.sensor = this.createNewSensorWithUUID('', SensorSource.Physical);

    this.allSensors.forEach(sensor => sensor.checked = false);
    this.sensor.checked = true;
    this.sensorsSelected = [this.sensor];

    this.preEditObjects = [ { sensorId: this.sensor.id, preEditObjectAsJSONString: JSON.stringify(this.sensor) } ];
    this.changeLogNotes = '';
    this.sensorSourceSelection = SensorSource[this.sensor.source];

    this.sensorModalRef = this.modalService.show(template, this.config);
  }


  editSensor(sensor: Sensor, template: TemplateRef<any>) {
    const sensorsToUpdate = this.sensorsDisplayed.filter(s => s.inlineEdited === true);
    if (sensorsToUpdate.length > 0) {
      this.toastr.info('Please finish inline editing or revert changes before editing this sensor');
      return;
    }

    this.selectedGps = this.displayedGps.find(x => x.id == sensor.gpsLocation.id);

    this.searchSensorForVirtualText = '';
    this.setSelectedUserGroup(sensor);

    this.preEditObjects = [ { sensorId: sensor.id, preEditObjectAsJSONString: JSON.stringify(sensor) } ];
    this.sensor = JSON.parse(JSON.stringify(sensor));

    this.changeLogNotes = '';
    this.sensorSourceSelection = SensorSource[sensor.source];

    this.allSensors.forEach(sensor => sensor.checked = false);
    sensor.checked = true;
    this.sensorsSelected = [this.sensor];

    const needsCalibrationHistory = this.sensor.sensorCalibrationHistory == undefined;
    const needsReadingTypes = this.sensor.sensorReadingTypes == undefined || this.sensor.sensorReadingTypes.length == 0;

    const calibrationHistory$ = needsCalibrationHistory
      ? this._sensorService.getCalibrationHistory([this.sensor.id], '')
      : of(null);

    const readingTypes$ = needsReadingTypes
      ? this._sensorService.getReadingTypesForSensors([this.sensor.id], 'Loading sensor data')
      : of(null);

    forkJoin([calibrationHistory$, readingTypes$]).subscribe({
      next: ([calResults, rtResults]) => {
        if (calResults != null) {
          this.processCalibrationHistoryResults(this.sensor, calResults);
        }
        if (rtResults != null) {
          this.sensor.sensorReadingTypes = rtResults;
          this.common.sortArrayByTypeParm(this.sensor.sensorReadingTypes);
          this.sensor.sensorReadingTypeNames = this.sensor.sensorReadingTypes.map(x => x.type).join(', ').toLowerCase();
        }
        this.sensorModalRef = this.modalService.show(template, this.config);
      },
      error: (err) => {
        this.toastr.error('Error loading sensor data');
        this.sensorModalRef = this.modalService.show(template, this.config);
      }
    });
  }


  onDeleteSensorConfirm(sensor) {
    this.confirmationService.confirm({
      key: 'cd',
      message: 'Delete virtual sensor \'' + this.common.getSensorDisplayName(sensor) + '\'? <br/><br/>NOTE: If you delete this sensor, all sensor readings associated with this sensor will also be DELETED. The sensor will be removed from all associationed Sensor Groups and Chart Favorites.<br/><br/>There is NO undo option.  Are you really sure you want to continue?' ,
      header: 'Delete SENSOR Confirmation',

      accept: () => {
        this.deleteSensor(sensor, 'Sensor deleted');
      },
      reject: () => {
      }
    });
  }


  deleteSensor(sensor: Sensor, message: string) {
    var sensorInfo = this.mapping.mapSensor2SensorInfo(sensor);
    this._sensorService.deleteSensor(sensorInfo, this.username).subscribe(
      results => {
        if (results != null) {
            this.createMessageData(MessageActionType.Deleted, sensor, "Deleted sensor " + this.common.getSensorDisplayName(sensor));
            this.toastr.success(message);
            var index = this.allSensors.findIndex(x => x.id == sensor.id);
            this.allSensors.splice(index,1);
            index = this.sensorsDisplayed.findIndex(x => x.id == sensor.id);
            this.sensorsDisplayed.splice(index,1);
        }
        else {
          this.toastr.warning('Unable to delete sensor. Msg: ' + results);
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while attempting to delete sensor');
      });
  }


  getAssociatedUserGroups(): void {
    this._userService.getAssociatedUserGroups(this.username).subscribe(
      results => {
        if (results != null) {
          this.isReadyAssociatedUserGroups = true;
          this.associatedUserGroups = results;
          this.getUserGroups();
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
    });
  }


  getUserGroups(): void {
    this._userService.getUserGroups().subscribe(
      results => {
        if (results != null) {
          this.userGroups = results;
          this.getAllSensors();
        }
        else {
          this.toastr.warning('No user groups found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving all user groups');
      });
  }


  showSelectedSensors() {
    this.sensorsDisplayed = this.allSensors.filter(x => x.checked == true);
  }


  sensorCheckedChanged() {
    this.sensorsSelected = this.allSensors.filter(x => x.checked == true);

    this.sensorsSelected.forEach(sensor => {
      if (sensor.sensorReadingTypeNames == '') {
        this.getSensorReadingTypes(sensor, undefined, '');
      }
    });
  }


  toggleCheckedSensorsDisplayed() {
    if (this.sensorsDisplayed == undefined || this.sensorsDisplayed.length < 1) {
      return;
    }

    var newState = !this.sensorsDisplayed[0].checked;
    this.sensorsDisplayed.forEach(sensor => {
      if (sensor.source != SensorSource.Internal && sensor.userFeatureAccess['EditSensor'] == true) {
        sensor.checked = newState;
      }
    });

    this.sensorCheckedChanged();
  }


  removeNulls(parameters: number[]): number[] {
    var newParms: number[] = [];
    parameters.forEach(x => (x == undefined || x == null) ? newParms.push(0) : newParms.push(x));
    return newParms;
  }


  getSensorDisplayNameUsingId(sensorId: number): string {
    var sensor = this.allSensors.find(x => x.id == sensorId);
    if (sensor == undefined) return;
    return (sensor.name != undefined && sensor.name != '') ? sensor.name : sensor.uuid ;
  }

  sensorHasActiveCalibrations(sensor: Sensor): boolean {
    if (sensor.sensorCalibrationHistory != undefined && sensor.sensorCalibrationHistory.length > 0 && sensor.sensorCalibrationHistory.some(x => x.isActive)) {
      return true;
    }
    return false;
  }


  setOwnerForSensors(template: TemplateRef<any>) {
    this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    this.setOwnerModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  updateOwnerForSelectedSensors() {
    if (!this.checkWriteAccessForSensors(this.sensorsSelected)) {
      this.toastr.warning('You don\'t have write access to all selected sensors');
      return;
    }

    this.preEditObjects = [];
    this.sensorsSelected.forEach(sensor => {
      this.preEditObjects.push( { sensorId: sensor.id, preEditObjectAsJSONString: JSON.stringify(sensor) });
      sensor.modifiedDate = new Date();
      sensor.userName = this.username;
      sensor.inlineEdited = true;
      this.updateUserInfoForSensor(sensor);
    });

    this.updateSensors(this.sensorsSelected);
    this.setOwnerModalRef.hide();
  }


  checkWriteAccessForSensors(sensors: Sensor[]): boolean {
    sensors.forEach(sensor => {
      if (sensor.userFeatureAccess["EditSensor"] == false) {
        return false;
      }
    });
    return true;
  }


  datesUpdated() { }

  
  selectedGpsLocationChanged(selection) {
    if (this.selectedGps == undefined || this.selectedGps.name == "Empty") {
      this.sensor.gpsLocation = this.newGpsInfo();
      return;
    }

    this.sensor.gpsLocation = JSON.parse(JSON.stringify(this.allGpsInfos.find(x => x.id == selection.id)));
  }


  checkForNewLocation(sensor: Sensor) {
    var gspInfo = this.allGpsInfos.find(x => x.gpsAlt == sensor.gpsLocation.gpsAlt &&
                                             x.gpsLat == sensor.gpsLocation.gpsLat &&
                                             x.gpsLong == sensor.gpsLocation.gpsLong &&
                                             x.locationDescription.toLowerCase() == sensor.gpsLocation.locationDescription.toLowerCase());
    if (gspInfo != undefined) {
      this.selectedGps = this.displayedGps.find(x => x.id == gspInfo.id);
    }
    else {
      this.selectedGps = this.displayedGps.find(x => x.name == "New");
    }
  }


  selectReadingsForGPS(template: TemplateRef<any>) {
    this.processingSensorReadingsForGpsResults = '';
    if (this.selectedGps == undefined) {
      this.toastr.warning('No GPS info selected.');
    }

    this.dataRangeSelectorTitle = 'Set GPS Location for Sensor Readings';
    this.dateRangeSelectorRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  updateSensorReadingsWithNewGpsInfo() {
    var updateCriteria: SensorReadingUpdateCriteria = {
      sensorId: this.sensor.id,
      gpsLocation: this.sensor.gpsLocation,
      startDate: this.selectedDateRange.startDate.toDate(),
      endDate: this.selectedDateRange.endDate.toDate()
    }

    this.processingSensorReadingsForGps = true;

    this._sensorService.updateSensorReadingsWithNewGpsInfo(updateCriteria).subscribe(
      results => {
        if (results != null) {
          this.processingSensorReadingsForGpsResults = 'Updated: ' + results;
          this.toastr.success('Number Readings updated: ' + results);
          this.processingSensorReadingsForGps = false;
        }
        else {
          this.toastr.warning('Error while updating sensor readings');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while updating GPS locations.');
      });
  }


  startReplaceSensor(template: TemplateRef<any>) {
    this.sensorModalRef = undefined;
    this.existingSensorUUID = '';
    this.replacementSensorUUID = '';
    this.existingSensorReadingsCheck = false;
    this.replacementSensorUUIDExists = false;
    this.existingSensorReadingsCount = "";
    this.sensorReplaceModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  openScan2Replace(template: TemplateRef<any>, existingSensor: boolean) {
    this.scanningExistingSensor = existingSensor;
    this.scanModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  public selectSensor(): void {
    if (this.scannedSensor == undefined || this.scannedSensor === '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }

    this.scannedSensor = this.createUUID(this.scannedSensor);

    if (this.scanningExistingSensor) {
      this.existingSensorUUID = this.scannedSensor.trim().toLowerCase();
    }
    else {
      this.replacementSensorUUID = this.scannedSensor.trim().toLowerCase();
    }

    this.existingSensorReadingsCheck = false;
    this.scannedSensor = '';
    this.scanModalRef.hide();
  }


  checkUUIDExistInSystem() {
    this.existingSensorReadingsCount = "";
    this.replacementSensorUUIDExists = false;
    this.existingSensorUUID = this.existingSensorUUID.toLowerCase();
    this.replacementSensorUUID = this.replacementSensorUUID.toLowerCase();

    var existingSensor = this.allSensors.find(x => x.uuid.toLowerCase() == this.replacementSensorUUID);
    if (existingSensor != undefined) {
      this.replacementSensorUUIDExists = true;
      this.getReadingsCountForSensor(existingSensor.id);
    }

    this.existingSensorReadingsCheck = true;
  }


  replaceSensor() {
    var replaceSensorPart3Required: boolean = true;

    if (this.existingSensorUUID == this.replacementSensorUUID) {
      this.toastr.warning('Existing and new sensor UUIDs can not be the same');
      return;
    }

    var sensorToReplace = this.allSensors.find(x => x.uuid.toLowerCase() == this.existingSensorUUID);

    if (sensorToReplace == undefined) {
      this.toastr.warning('The given existing sensor not found in the system');
      return;
    }
    else {
      if (sensorToReplace.source != SensorSource.Physical) {
        this.toastr.warning("You can only replace 'physcial' sensors.");
        return;
      }
    }

    var replacementSensor = this.allSensors.find(x => x.uuid.toLowerCase() == this.replacementSensorUUID);
    
    if (replacementSensor != undefined) {
      if (sensorToReplace.source != SensorSource.Physical || replacementSensor.source != SensorSource.Physical) {
        this.toastr.warning("Both sensors must be classified as a 'physical' sensor");
        return;
      }

      var sensorgroup = this.findSensorGroupUsingUUID(replacementSensor);
      if (sensorgroup != undefined) {
        this.toastr.warning('The given replacement sensor is being used in a sensor group: ' + sensorgroup.name + '. Cannot be used to replace another this.sensor.');
        return;
      }

      replaceSensorPart3Required = false;
      this. replaceSensor_Part2_DeleteReplacementSensor(replacementSensor, sensorToReplace, 'Cleaning up data with replacement sensor');
    }

    if (replaceSensorPart3Required) {
      this.replaceSensor_Part3_UpdateExistingSensorUUIDwithReplacementSensorUUID(sensorToReplace);
    }

    this.sensorReplaceModalRef.hide();
  }


  replaceSensor_Part2_DeleteReplacementSensor(replacementSensor: Sensor, sensorToReplace: Sensor, message: string) {
    var sensorInfo = this.mapping.mapSensor2SensorInfo(replacementSensor);
    this._sensorService.deleteSensor(sensorInfo, this.username).subscribe(
      results => {
        if (results != null) {
            this.createMessageData(MessageActionType.Edited, sensorToReplace, "Replaced Sensor " + this.common.getSensorDisplayName(sensorToReplace) + ' with ' + this.common.getSensorDisplayName(replacementSensor));
            
            var index = this.allSensors.findIndex(x => x.id == replacementSensor.id);
            if (index > -1) {
              this.allSensors.splice(index,1);
            }
            index = this.sensorsDisplayed.findIndex(x => x.id == replacementSensor.id);
            if (index > -1) {
              this.sensorsDisplayed.splice(index,1);
            }
            
            this.replaceSensor_Part3_UpdateExistingSensorUUIDwithReplacementSensorUUID(sensorToReplace);
        }
        else {
          this.toastr.warning('Unable to clean up data associated with the replacement sensor');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while attempting to clean up data associated with the replacement sensor');
      });
  }


  replaceSensor_Part3_UpdateExistingSensorUUIDwithReplacementSensorUUID(sensorToReplace: Sensor) {
    this.preEditObjects = [ { sensorId: sensorToReplace.id, preEditObjectAsJSONString: JSON.stringify(sensorToReplace) } ];

    sensorToReplace.uuid = this.replacementSensorUUID;
    var newName = this.common.extractNameFromUUID(this.replacementSensorUUID, this.btMacAddressPrefixes);
    sensorToReplace.name = (newName != undefined && newName != '') ? newName : null;
    this.sensorSourceSelection = 'Physical';

    this.setSelectedUserGroup(sensorToReplace);
    this.updateOrCreateSensor(sensorToReplace, false);
  }


  findSensorGroupUsingUUID(sensor: Sensor): SensorGroup {
    var group: SensorGroup;
    this.sensorGroups.forEach(x => {
      if (x.sensors.map(y => y.id).includes(sensor.id)) {
        group = x;
      }
    });

    return group;
  }


  getReadingsCountForSensor(sensorId: number) {
    var readingCriteria: SensorReadingCriteria = {
      sensorId: sensorId,
      startDate: moment.utc().add(-5, "years").format('YYYY-MM-DD HH:mm'),  // moment.utc().add(-5, "years").toDate(),
      endDate: moment.utc().add(5, "hours").format('YYYY-MM-DD HH:mm'),      // moment.utc().add(1, "hour").toDate(),
      timeZoneDisplay: this.selectedTimeZone,
      timeZoneOffset: this.selectedTimeZoneOffset
    }

    this._sensorService.countReadings(readingCriteria).subscribe(results => {
      if (results != null) {
        this.existingSensorReadingsCount = <string>results;
      } else {
        this.toastr.warning('Error getting readings count');
      }
    });
  }


  showSensorDataPreview(sensor: Sensor): void {
    const params: SensorDataModalParams = {
      sensor: sensor,
      selectedTimeZone: this.selectedTimeZone,
      selectedTimeZoneOffset: this.selectedTimeZoneOffset,
      selectedDateRange: { startDate: moment().startOf('day').subtract(1, 'days'), endDate: moment().endOf('day') },
      selectedDefaultReadingType: ''
    };

    this.modalService.show(SensorDataModalComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  openVirtualSensorModal() {
    //this.buildVirtualDisplayListFromParameters(this.sensor);

    var params: VirtualSensorModalParams = {
      sensor: this.sensor,
      allSensors: this.allSensors,
      allGpsInfos: this.allGpsInfos,
      sensorReadingTypes: this.sensorReadingTypes
    };

    this.modalService.show(VirtualSensorModalComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  deleteSensorReadingDataConfirmation1(template: TemplateRef<any>) {
    this.confirmationService.confirm({
      message: 'Warning - You cannot undo deletion of sensor reading data. Are you sure you want to proceed with selecting date ranges and reading types to delete?',
      header: 'Confirmation',
      icon: 'pi pi-info-circle',
      key: 'confirmDelete1',
      accept: () => {
        this.dataRangeSelectorTitle = "Delete Sensor Readings"
        this.readingTypesByCount = [];
        this.dateRangeSelectorRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
      },
      reject: () => {
      }
    });
  }


  deleteSensorReadingDataConfirmation2() {
    if (this.readingTypesByCount.filter(x => x.checked).length < 1) {
      this.toastr.warning('Must select one or more reading types to delete!');
      return;
    }

    this.confirmationService.confirm({
      message: 'Warning - This will delete sensor readings for the given sensor, selected types, and date ranges.  Are you sure you want to proceed with deleting?',
      header: 'Confirmation',
      icon: 'pi pi-info-circle',
      key: 'confirmDelete2',
      accept: () => {
        this.resultsOfSensorReadingDeletion = "";
        this.deleteSensorReadingsForReadingTypes();
      },
      reject: () => {
      }
    });
  }


  getReadingStatsForDateRange() {
    var readingCriteria: SensorReadingCriteria = {
      sensorId: this.sensor.id,
      startDate: this.selectedDateRange.startDate.startOf('day').format('YYYY-MM-DD HH:mm'), 
      endDate: this.selectedDateRange.endDate.endOf('day').format('YYYY-MM-DD HH:mm'),
      timeZoneDisplay: TimeZoneDisplay.UTC,
      timeZoneOffset: 0
    }

    this.processingReadingCounts = true;
    this.resultsOfSensorReadingDeletion = "";
    this.readingTypesByCount = [];

    this._sensorService.getReadingCountsByReadingTypeForDateRange(readingCriteria).subscribe(
      results => {
        if (results != null) {
          this.readingTypesByCount = results;
        }

        if (this.readingTypesByCount.length < 1) {
          this.resultsOfSensorReadingDeletion = "no readings found"
        }
        
        this.processingReadingCounts = false;
        return;
      },
      err => {
        this.processingReadingCounts = false;
        this.toastr.error('Error occurred while retrieving sensor reading counts');
      });

  }
  

  deleteSensorReadingsForReadingTypes() {
    var readingCriteria: SensorReadingCriteria = {
      sensorId: this.sensor.id,
      startDate: this.selectedDateRange.startDate.startOf('day').format('YYYY-MM-DD HH:mm'), 
      endDate: this.selectedDateRange.endDate.endOf('day').format('YYYY-MM-DD HH:mm'),
      timeZoneDisplay: TimeZoneDisplay.UTC,
      timeZoneOffset: 0,
      sensorReadingTypes: this.readingTypesByCount.filter(x => x.checked)
    }

    if (readingCriteria.sensorReadingTypes == undefined || readingCriteria.sensorReadingTypes.length < 1) {
      this.toastr.warning('Must select one or more reading types to delete!');
      return;
    }

    this.processingReadingCounts = true;

    this._sensorService.deleteSensorReadingsForReadingTypes(readingCriteria).subscribe(
      results => {
        if (results != null) {
          this.resultsOfSensorReadingDeletion = 'Deleted: ' + results;
          this.toastr.success('Readings deleted: ' + results);
        }
        this.processingReadingCounts = false;
        return;
      },
      err => {
        this.processingReadingCounts = false;
        this.toastr.error('Error occurred while deleting sensor readings');
      });
  }


  toggleCheckedSensorReadingsForDeletion() {
    if (this.readingTypesByCount == undefined || this.readingTypesByCount.length < 1) {
      return;
    }

    var newState = !this.readingTypesByCount[0].checked;
    this.readingTypesByCount.forEach(readingType => {
        readingType.checked = newState;
    });
  }


  updateSensorWithSearchResults(sensor: Sensor, sensorWithResults: Sensor) {
    sensor.searchResultsSummary = "";

    if (sensorWithResults.searchResults == undefined) return;

    for(var key in sensorWithResults.searchResults) {
      var value = this.common.setValuePrecisionForKey(Number(sensorWithResults.searchResults[key]), key);
      
      if (key.toLowerCase() == "createddate") {
      }
      else {
        sensor.searchResultsSummary += key + "=" + value.toString();
      }
    }
  }


  findAssociatedSensorGroupNames(sensor: Sensor) {
    var associatedGroups = "";

    this.sensorGroups.forEach(group => {
      group.sensors.forEach(groupsensor => {
        if (groupsensor.uuid.toLowerCase() == sensor.uuid.toLowerCase()) {
          associatedGroups += group.name + ", ";
        }
      });
    });

    sensor.associatedsensorGroupNames = associatedGroups;
  }


  createOrUpdateSensorgroup() {
    var selectedSensors = this.sensorsDisplayed.filter(x => x.checked);
    if (selectedSensors == undefined || selectedSensors.length < 1) {
      this.toastr.warning('Need to select sensors for sensor group');
      return;
    }

    var selectedUserGroup = (selectedSensors[0].userGroup == undefined || selectedSensors[0].userGroup == '') ? null : this.userGroups.find(x => x.id == selectedSensors[0].userGroupId);
    
    const params: QuickCreateSensorgroupParams = {
      sensorsDisplayed: JSON.parse(JSON.stringify(this.sensorsDisplayed.filter(x => x.checked))),
      selectedUserGroup: selectedUserGroup,
      userGroups: this.userGroups,
    };

    this.modalService.show(QuickCreateSensorgroupComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  showSensorImportModal(): void {
    const params: ImportSensorModalParams = {
      allSensors: this.allSensors,
      userGroups: this.userGroups
    };

    this.modalService.show(ImportSensorComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params })
    .onHide
    .subscribe(() => {
      this.getGpsLocations();
    });
  }


  showSensorLabelModal(uuid: string): void {
    const params: SensorLabelModalParams = {
      uuid: uuid,
      btMacAddressPrefixes: this.btMacAddressPrefixes
    };

    this.modalService.show(SensorLabelComponent, { animated: false, backdrop: false, ignoreBackdropClick: false, initialState: params });
  }

  
  sensorHasBlinkNowCapability(sensor: Sensor): boolean {
    if (sensor.type == undefined || sensor.type == '') {
      return false;
    }

    var sensorTypeName = sensor.type.toLowerCase();

    if (sensorTypeName == "miflora") {
      return true;
    }
    return false;
  }


  blinkSensorNow(sensor: Sensor) {
    this._sensorService.blinkSensor(sensor.id).subscribe(
      results => {
        if (results != null) {
          this.toastr.warning('Success:  Sensor should be blinking now if it is connected and within range.');
        }
        else {
          if (sensor.type.toLowerCase() != "miflora") {
            this.sensorDataOnDemandMessage = 'Request timed out, gateway could not be located, or the sensor did not respond. Note: Associated KIG gateways needs to be v5.8.4 or greater';
            this.toastr.warning('Request timed out, gateway could not be located, or the sensor did not respond.');
          }
        }
      },
      err => {
        this.toastr.error('Error occurred while locating or connecting to the sensor');
      });
  }


  sensorHasReadNowCapability(sensor: Sensor): boolean {
    if (sensor.type == undefined || sensor.type == '') {
      return false;
    }

    var sensorTypeName = sensor.type.toLowerCase();

    if (sensorTypeName == "miflora" || sensorTypeName == "sensorpush" || sensorTypeName == 'mithermo' ||
        sensorTypeName == 'thermo' || sensorTypeName == 'particle' || sensorTypeName == 'govee' || sensorTypeName == 'guardian') {
      return true;
    }
    return false;
  }


  captureSensorReadingNow(sensor: Sensor, template: TemplateRef<any>) {
    this.sensorDataOnDemandMessage = "";

    this.sensorDataOnDemandResults = {
      UUID: "",
      Tag: "",
      PayLoad: { ["no results"] : "" },
      CreatedDate: new Date()
    }

    this._sensorService.captureSensorReading(sensor.id).subscribe(
      results => {
        if (results != null) {
          this.sensorDataOnDemandResults = results;
          this.sensorDataOnDemandResults.CreatedDate = moment.utc(results.CreatedDate).local().toDate();
          this.sensorDataOnDemandResults.PayLoad = JSON.parse(results.PayLoad);
        }
        else {
          if (sensor.type.toLowerCase() != "particle") {
            this.sensorDataOnDemandMessage = 'Request timed out, gateway could not be located, or the sensor did not respond. Note: Associated KIG gateways needs to be v5.5.0 or greater';
            this.toastr.warning('Request timed out, gateway could not be located, or the sensor did not respond.');
          }
          else {
            this.sensorDataOnDemandMessage = 'Not able to contact the Particle Cloud or the sensor did not respond.';
            this.toastr.warning('Not able to contact the Particle Cloud or the sensor did not respond.');
          }
        }

        this.sensorDataOnDemandName = this.common.getSensorDisplayName(sensor);
        this.sensorDataResultsModelRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
        return;
      },
      err => {
        this.toastr.error('Error occurred while locating or connecting to the sensor');
      });
  }

  
  sensorTypeChanged() {
    if (this.sensor.id < 1 && this.sensor.type.toLowerCase() == 'met3') {
      var newUUID = this.sensor.uuid.replace(/:/g, '');
      newUUID = newUUID.replace(/ /g, '');

      if (newUUID.length > 11) {
        newUUID = newUUID.substr(newUUID.length - 12).toUpperCase();
        this.sensor.uuid = 'MET3-' + newUUID;
      }
    }
  }


  loadCalibrationHistoryForSensors(sensors: Sensor[]) {
    this.loadingCalibrationHistory = true;

    this._sensorService.getCalibrationHistory(sensors.map(s => s.id), '').subscribe(
      results => {
        if (results != null) {
          sensors.forEach(sensor => {
            var sensorResults = results.filter(x => x.sensorId == sensor.id);
            this.processCalibrationHistoryResults(sensor, sensorResults);
          });
        }
        // else {
        //   this.toastr.warning('No calibration history found for this sensor'); 
        // }
        this.loadingCalibrationHistory = false;
      },
      err => {
        this.toastr.error('Error occurred while retrieving calibration history for sensors');
        this.loadingCalibrationHistory = false;
      });
  }


  processCalibrationHistoryResults(sensor: Sensor, results: any) {
    sensor.sensorCalibrationHistory = this.mapping.mapCalibrationHistoryInfos2CalibrationHistory(results);

    sensor.sensorCalibrationHistory.forEach(calibration => {
      calibration.startDate = moment.utc(calibration.startDate).local().toDate();
      calibration.modifiedDate = moment.utc(calibration.modifiedDate).local().toDate();
      calibration.templateName = (calibration.equationId == -1) ? "none" : (calibration.equationId == 0) ? "1-Deg" : (calibration.equationId == 1) ? "2-Deg" : (calibration.equationId == 2) ? "3-Deg" : "unknown"; 
      calibration.modifiedByUserName = (calibration.modifiedByUserName == undefined || calibration.modifiedByUserName == '') ? 'api' : calibration.modifiedByUserName.split('@')[0];
      calibration.parametersDisplay = this.common.getFormattedSensorCalibrationParameters(calibration.equationId, JSON.stringify(calibration.parameters));
      calibration.dropDownDisplayName = moment(calibration.startDate).format("MMM DD YYYY, HH:mm") + (calibration.isActive ? ' (Active)' : '');
      calibration.notesObj = this.parseCalibrationNotes(calibration.notes);
      calibration.sensorReadingTypeName = this.sensorReadingTypes.find(x => x.id == calibration.sensorReadingTypeId)?.type || '';
    });

    var ascending = false;
    sensor.sensorCalibrationHistory.sort((a, b) => {
      if (b.startDate > a.startDate) {
        return (ascending ? -1 : 1);
      }
      if (b.startDate < a.startDate) {
        return (ascending ? 1 : -1);
      }
      return 0;
    });

    this.calibrationHistory = sensor.sensorCalibrationHistory;
  }

  
  parseCalibrationNotes(notes: string): SensorCalibrationHistoryNotes {
    let notesObj: SensorCalibrationHistoryNotes = {
      userNotes: '',
      grade: 0,
      sensorSerialNumber: ''
    };

    try {
      if (notes != undefined && notes != '') {
        const notesObjTemp = JSON.parse(notes);
        notesObj.userNotes = notesObjTemp.userNotes || '';
        notesObj.grade = notesObjTemp.grade || 0;
        notesObj.sensorSerialNumber = notesObjTemp.sensorSerialNumber || '';
      }
    }
    catch (e) {
      notesObj.userNotes = notes;
    }

    return notesObj;
  }


  onActiveCalibrationChanged(event: { calibrationId: number, isActive: boolean, sensorReadingTypeId: number }) {
    this.notifyCalibrationHistoryActiveChanged = event.calibrationId;
  }


  createOrUpdateCalibrationHistory(sensor: Sensor) {
    var sensorCalibrationHistoryInfos: SensorCalibrationHistoryInfo[] = [];

    sensor.sensorCalibrationHistory.forEach(calibration => {
      var calibrationHistoryInfo: SensorCalibrationHistoryInfo = this.mapping.mapCalibrationHistory2CalibrationHistoryInfo(calibration);

      var users = this.userGroups.map(u => u.userInfos).reduce((acc, val) => acc.concat(val), []);
      var userId = users.filter(u => u.userName.toLowerCase() == this.username.toLowerCase()).map(u => u.id)[0] || 0;

      calibrationHistoryInfo.modifiedByUserId = userId;
      calibrationHistoryInfo.modifiedByUserName = this.username;
      calibrationHistoryInfo.modifiedDate = moment().utc().toDate();
      calibrationHistoryInfo.sensorName = this.common.getSensorDisplayName(sensor);
      calibrationHistoryInfo.notes = JSON.stringify(this.parseCalibrationNotes(calibration.notes?.toString() || ''));

      sensorCalibrationHistoryInfos.push(calibrationHistoryInfo);
    });

    if (sensorCalibrationHistoryInfos.length > 0) {
      this._sensorService.createOrUpdateCalibrationHistory(sensorCalibrationHistoryInfos).subscribe(
        results => {
          if (results === 'success' || results == null) {
            
          } else {
            this.toastr.error('Error creating calibration history: ' + results);
          }
        },
        err => {
          this.toastr.error('Error creating calibration history record: ' + err);
        });
    }
  }


}
